var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-3"},[_vm._v("等待游戏开始...")])
}
var staticRenderFns = []

export { render, staticRenderFns }